import { createContext } from "react";
import { IToasterProps } from "Views/Categories/types";

export interface ICategoryContext {
  setToaster: (toaster: IToasterProps) => void;
  refetch: (importedCategory) => void;
}

export const CategoryContext = createContext<ICategoryContext>({} as ICategoryContext);
